import ApiService from "@/core/services/api.service";

//Actions
export const FETCH_PROVIDERS_BASIC = "fetchProvidersBasic";

//Mutations
export const SET_LOADING = "setLoadingSharedProvider";

const state = {
  isLoadingSharedProvider: false
};

const getters = {
  isLoadingSharedProvider() {
    return state.isLoadingSharedProvider;
  }
};

const actions = {
  [FETCH_PROVIDERS_BASIC](context, apiParams = "") {
    context.commit(SET_LOADING, true);
    return new Promise((resolve, reject) => {
      ApiService.get("providers-basic" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
};

const mutations = {
  [SET_LOADING](state, value) {
    state.isLoadingSharedProvider = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
